import { Injectable } from '@angular/core';
import {isNotNullOrUndefined} from "codelyzer/util/isNotNullOrUndefined";

@Injectable({
  providedIn: 'root'
})
export class LmService {

  constructor() { }

  setLMRunning(topologyId:string,isRunning: boolean) {
    localStorage.setItem("isLMRunning_"+topologyId, "" + isRunning);
  }

  isLMRunning(topologyId:string) {
    let isLMRunning: boolean = false;

    let isLMRunningStr: string = localStorage.getItem("isLMRunning_"+topologyId);
    if (isNotNullOrUndefined(isLMRunningStr)) {
      if(isLMRunningStr == "true"){
        isLMRunning = true;
      }
    }

    return isLMRunning;
  }


  setCMRunning(topologyId:string,isRunning: boolean) {
    localStorage.setItem("isCMRunning_"+topologyId, "" + isRunning);
  }

  isCMRunning(topologyId:string) {
    let isCMRunning: boolean = false;
    let isCMRunningStr: string = localStorage.getItem("isCMRunning_"+topologyId);;
    if (isNotNullOrUndefined(isCMRunningStr)) {
      if(isCMRunningStr == "true"){
        isCMRunning = true;
      }
    }

    return isCMRunning;
  }

  saveInputFieldValue(key: string, value: string){
    localStorage.setItem(key, value);
  }

  getSavedIputFieldValue(key: string){
    return localStorage.getItem(key)
  }
}
